<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-2">
            <v-card-title>
              <h4>Détail de la dénonciation</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <b>Prenom: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].prenom || "Non défini" }}
              <v-spacer class="my-1"></v-spacer>
              <b>Nom: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].nom || "Non défini" }}
              <v-spacer class="my-1"></v-spacer>
              <b>Email: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].email || "Non défini" }}
              <v-spacer class="my-1"></v-spacer>
              <b>Type de dénonciation: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].typeDenonciation }}
              <v-spacer class="my-1"></v-spacer>
              <b>Objet de dénonciation: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].denonciationObjet }}
              <v-spacer class="my-1"></v-spacer>
              <b>Date Dénonciation: </b>
              {{ this.$store.getters["Auth/get_selected_denonciation"].dateDemande }}
            </v-card-text>
          </v-card>
  
        </v-col>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>
              <h4>Aperçu de la dénonciation</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height:62em !important;overflow:hidden">
              <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_denonciation'].fileType == 'doc' ||
                this.$store.getters['Auth/get_selected_denonciation'].fileType == 'docx' ||
                this.$store.getters['Auth/get_selected_denonciation'].fileType == 'xls' ||
                this.$store.getters['Auth/get_selected_denonciation'].fileType == 'xlsx' ||
                this.$store.getters['Auth/get_selected_denonciation'].fileType == 'XLS' ||
                this.$store.getters['Auth/get_selected_denonciation'].fileType == 'XLSX'
                " :value="this.$store.getters['Auth/get_selected_denonciation'].fileLink" type="office" />
  
              <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_denonciation'].extension == 'pdf'"
                :src="this.$store.getters['Auth/get_selected_denonciation'].fileLink + '#toolbar=0'
                " frameborder="0" loading="lazy"></vue-friendly-iframe>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import VueDocPreview from "vue-doc-preview";
  
  export default {
    components: {
      VueDocPreview
    },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data: () => ({
      profile: 0,
      dialog: false,
    }),
    created() {
      this.$store.dispatch("Auth/loadDenonciationById", this.id);
      let Virt = [];
      Virt = JSON.parse(localStorage.getItem("userData"));
      this.profile = Virt.profile.status;
    },
    computed: {
      status() {
        return this.$store.getters['Auth/get_selected_denonciation'].status;
      }
    },
    methods: {
      getInit() {
        this.InitLink = this.$store.getters["Auth/get_selected_denonciation"].file_link;
      }
    }
  };
  </script>
  <style>
  .w-62em {
    height: 62em !important;
    width: 100% !important;
  }
  
  .v-card__text {
    width: 100% !important;
  }
  
  .vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
  }
  </style>